// @flow
import { menuBarActions } from './menuBarActionCreator';

const initialState = {
  columnWiseRoutes: [],
  isMenuBarVisible: false
};

const menuBarReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case menuBarActions.Set_Column_Wise_Routes: {
      return Object.assign({}, state, { columnWiseRoutes: action.payload });
    }
    case menuBarActions.Show_Hide_MenuBar: {
      return Object.assign({}, state, { isMenuBarVisible: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default menuBarReducer;
